export function getFileStorageUrl(bucket: string | null, path: string): string {
  const config: any = useRuntimeConfig()
  return `${config.public.supabase.url}/storage/v1/object/public/${bucket ? bucket + '/' : ''}${path}`;
}

